// extracted by mini-css-extract-plugin
module.exports = {"productMenuItem":"UserMenu_productMenuItem__Awg4Z"};